var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-input',{staticClass:"no-border e-invoice tax-id-input",attrs:{"type":_vm.types,"inputmode":'numeric',"placeholder":"+新增","maxlength":8},model:{value:(_vm.vModel),callback:function ($$v) {_vm.vModel=$$v},expression:"vModel"}})}
var staticRenderFns = []

export { render, staticRenderFns }